/**
 * The one formatter for amounts (scripts/quality/audit-money.mjs flags a hand-placed "₹").
 * API money arrives as decimal strings ("112.00"); a value that isn't a number renders as-is.
 */

const INR = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatINR(amount: string | number): string {
  const n = typeof amount === "number" ? amount : Number(amount);
  return Number.isFinite(n) ? INR.format(n) : String(amount);
}

// Indian compact notation from ₹1,000: ₹12.9K, ₹1.2L (lakh), ₹3.4Cr (crore); whole rupees below.
const INR_COMPACT = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  notation: "compact",
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});
const INR_WHOLE = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });

/** An amount at a glance — dashboard tiles and chart axes: ₹647, ₹12.9K. Exact amounts use `formatINR`. */
export function formatINRCompact(amount: string | number): string {
  const n = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(n)) return String(amount);
  return Math.abs(n) < 1000 ? INR_WHOLE.format(n) : INR_COMPACT.format(n);
}
